import { Star, FolderX } from 'lucide-react'
import { useBrowseCalendarEvents } from '@/hooks/usePlanBrowse'
import { FolderCard } from './FolderCard'
import { FolderGrid, FolderGridSkeleton } from './FolderGrid'
import type { BrowseEventSelection } from '@/stores/useBrowseStore'

interface EventGridProps {
  departmentId: string
  calendarId: string
  onSelect: (event: BrowseEventSelection) => void
}

export function EventGrid({
  departmentId,
  calendarId,
  onSelect,
}: EventGridProps) {
  const { data, isLoading } = useBrowseCalendarEvents(departmentId, calendarId)

  const events = data?.data ?? []

  if (isLoading) return <FolderGridSkeleton label="Loading events" />

  if (events.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-16 text-muted-foreground">
        <FolderX className="h-10 w-10" />
        <p className="text-sm">No events found</p>
      </div>
    )
  }

  return (
    <FolderGrid>
      {events.map(event => (
        <FolderCard
          key={event.event_id}
          icon={<Star className="h-6 w-6" />}
          title={event.event_name}
          subtitle={`${event.plan_count} plan${event.plan_count !== 1 ? 's' : ''}`}
          onClick={() =>
            onSelect({ eventId: event.event_id, eventName: event.event_name })
          }
        />
      ))}
    </FolderGrid>
  )
}
